import {Link} from 'react-router-dom'

function Button(props) {
    return (
        <Link to={props.path} style={{textDecoration: 'none'}} class={props.style}>{props.name}</Link>
    )
}

export default Button